"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tippy = exports.GlobalStyle = void 0;
var _react = _interopRequireDefault(require("@tippy.js/react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../../components/breakpoints"));
const {
  nobel
} = require("../../components/LexusTypography");
const {
  ToyotaType
} = require("../../components/ToyotaTypography");

// Todo: audit whether all these styles are needed - direct import from old tippy version
const GlobalStyle = exports.GlobalStyle = (0, _styledComponents.createGlobalStyle)`
    .tippy-tooltip[data-animation=fade][data-state=hidden] {
        opacity: 0
    }

    .tippy-iOS {
        cursor: pointer!important;
        -webkit-tap-highlight-color: transparent;
    }

    .tippy-popper {
        z-index: 99999!important;
        pointer-events: none;
        max-width: calc(100vw - 10px);
        transition-timing-function: cubic-bezier(.165,.84,.44,1);
        transition-property: transform;
        ${(0, _breakpoints.default)("tablet", "down")} {
            max-width: calc(100vw - 15px);
        }
    }

    .tippy-tooltip {
        position: relative;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
        line-height: 1.4;
        background-color: #333;
        transition-property: visibility,opacity,transform;
        outline: 0
    }

    .tippy-tooltip[data-placement^=top]>.tippy-arrow {
        border-width: 8px 8px 0;
        border-top-color: #333;
        margin: 0 3px;
        transform-origin: 50% 0;
        bottom: -7px
    }

    .tippy-tooltip[data-placement^=bottom]>.tippy-arrow {
        border-width: 0 8px 8px;
        border-bottom-color: #333;
        margin: 0 3px;
        transform-origin: 50% 7px;
        top: -7px
    }

    .tippy-tooltip[data-placement^=left]>.tippy-arrow {
        border-width: 8px 0 8px 8px;
        border-left-color: #333;
        margin: 3px 0;
        transform-origin: 0 50%;
        right: -7px
    }

    .tippy-tooltip[data-placement^=right]>.tippy-arrow {
        border-width: 8px 8px 8px 0;
        border-right-color: #333;
        margin: 3px 0;
        transform-origin: 7px 50%;
        left: -7px
    }

    .tippy-tooltip[data-interactive][data-state=visible] {
        pointer-events: auto
    }

    .tippy-tooltip[data-inertia][data-state=visible] {
        transition-timing-function: cubic-bezier(.54,1.5,.38,1.11)
    }

    .tippy-arrow {
        position: absolute;
        border-color: transparent;
        border-style: solid
    }

    .tippy-content {
        padding: 5px 9px
    }

`;
const Tippy = exports.Tippy = (0, _styledComponents.default)(_react.default)`
    &.tippy-tooltip[data-placement^=top] > .tippy-arrow {
        border-top-color: #000;
    }

    &.tippy-tooltip[data-placement^=bottom] > .tippy-arrow {
        border-bottom-color: #000;
    }

    &.tippy-tooltip[data-placement^=left] > .tippy-arrow {
        border-left-color: #000;
    }

    &.tippy-tooltip[data-placement^=right] > .tippy-arrow {
        border-right-color: #000;
    }

    &.MoreInfoContent-theme {
        background: #FFF;
        color: #000;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;

        & .tippy-content {
            padding: 0;
            box-sizing: border-box;
        }

        &.tippy-tooltip[data-placement^=top] > .tippy-arrow {
            border-top-color: #fff;
        }

        &.tippy-tooltip[data-placement^=bottom] > .tippy-arrow {
            border-bottom-color: #fff;
        }

        &.tippy-tooltip[data-placement^=left] > .tippy-arrow {
            border-left-color: #fff;
        }

        &.tippy-tooltip[data-placement^=right] > .tippy-arrow {
            border-right-color: #fff;
        }
    }

    &.FilterInfoContent-Lexus-theme, &.FilterInfoContent-Toyota-theme, &.AvailabilityTooltipContent-Toyota-theme {
        background: #FFF;
        color: #000;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;

        & .tippy-content {
            padding: 0;
            box-sizing: border-box;
        } 
    }

    &.FilterInfoContent-Lexus-theme {
        &.tippy-tooltip > .tippy-arrow {
            display: none;
        }
        .tooltipHeader{
            ${nobel({
  sizing: "body14",
  weight: "bold",
  spacing: "1.4"
})};
            text-transform: uppercase;
            margin-bottom: 15px;
        }
        .tooltipContent{
            max-height: 200px;
            overflow: scroll;
            .tooltipWrapper{
                margin-bottom: 15px;
                &:nth-child(2){
                    margin-bottom: 0px;
                }
                .tooltipSubheader{
                    ${nobel({
  sizing: "body14",
  weight: "bold",
  spacing: "0.56"
})};
                    margin-bottom: 15px;
                }
                ul{
                    padding-inline-start: 20px;
                    margin: 0;
                    li{
                        margin-bottom: 4px;
                        ${nobel({
  sizing: "body14",
  weight: "book",
  spacing: ""
})};
                        span {
                            display: none;
                        }
                    }
                }
            }
        }
    }

    &.FilterInfoContent-Toyota-theme, &.AvailabilityTooltipContent-Toyota-theme {
        & .tippy-content {
            padding: 0;
            box-sizing: border-box;
            button{
                width: 32px;
                height: 32px;
                border: solid 2px #767676;
                border-radius: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: transparent;
                svg {
                    stroke: #000;
                    stroke-width: 1px;
                    transform: scale(0.7);
                }
            }
        } 

        &.tippy-tooltip[data-placement^='top'] > .tippy-arrow {
            border-top-color: #fff;
            border-width: 8px 10px 0 10px;
        
          }
        &.tippy-tooltip[data-placement^='bottom'] > .tippy-arrow {
            border-bottom-color: #fff;
            border-width: 0 10px 8px 10px;
          }
        &.tippy-tooltip[data-placement^='left'] > .tippy-arrow {
            border-left-color: #fff;
            border-width: 10px 0 10px 8px;
        
          }
        &.tippy-tooltip[data-placement^='right'] > .tippy-arrow {
            border-right-color: #fff; 
            border-width: 10px 8px 10px 0;
          }
        
        .tooltipHeader{
            ${ToyotaType({
  sizing: "heading05",
  weight: "bold"
})};
            margin-bottom: 20px;
        }
        .tooltipContent{
            max-height: 200px;
            overflow: scroll;
            .tooltipWrapper{
                margin-bottom: 8px;
                &:nth-child(2){
                    margin-bottom: 0px;
                }
                .tooltipSubheader{
                    ${ToyotaType({
  sizing: "label10",
  weight: "bold"
})};
                    margin-bottom: 4px;
                }
                ul{
                    padding-inline-start: 20px;
                    margin: 0;
                    li{
                        margin-bottom: 4px;
                        ${ToyotaType({
  sizing: "label10",
  weight: "regular"
})};
                        span {
                            display: none;
                        }
                    }
                }
            }
        }
        

    }

    &.AvailabilityTooltipContent-Toyota-theme {
        & .tippy-content {
            button{
                border: none;
                border-radius: 0;
                width: 16px;
                height: 16px;
                svg {
                    width: 100%;
                    height: 100%;
                    transform: scale(1);
                    stroke-width: 0.5;
                }
            }
        } 
        .availabilityHeader {
            ${ToyotaType({
  sizing: "button01",
  weight: "bold"
})}
        }
    }

    &.AvailabilityTooltipContent-Lexus-theme {
        background: black;
        border-radius: 0px;
        & .tippy-content {
            text-transform: none;
            button{
                background: transparent;
                width: 15px;
                height: 15px;
                top: 10px;
                right:10px;
                svg {
                    width: 100%;
                    height: 100%;
                }
            }
        } 
        &.tippy-tooltip[data-placement^='top'] > .tippy-arrow {
            border-top-color: #000;
          }
        &.tippy-tooltip[data-placement^='bottom'] > .tippy-arrow {
            border-bottom-color: #000;
          }
        &.tippy-tooltip[data-placement^='left'] > .tippy-arrow {
            border-left-color: #000;
          }
        &.tippy-tooltip[data-placement^='right'] > .tippy-arrow {
            border-right-color: #000; 
          }
    }

    ${(0, _breakpoints.default)("tablet", "up")} {
        &[data-placement^="left"] {
            left: -4px !important;
        }

        &[data-placement^="right"] {
            left: 2px !important;
        }
    }
`;